import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'

import { withProcedureWraper } from '../..'
import { Routes } from '../../../../AppRoutes'
import { Box } from '../../../../components/box'
import { Icon } from '../../../../components/icon'
import { Table } from '../../../../modules/table'
import { useSelector } from '../../../../store/store'
import {ITToolRequestService } from '../../../../services/it-tools-request/itToolRequest.service'
import { getDDMMYYYFormat } from '../../../../helper/dateTimeHelper'
import { approverType, toolTechnologyRequestTypes } from '../tool-technology/toolTechnologyRequestType'
import { requestStatus } from '../../../../constants/statusConstants'
import ApprovalStatus from '../../../../components/status/approvalStatus'
import { Button } from 'react-bootstrap'
import FontFa from '../../../../components/fontFa/fontFa'

export const procedureProcessToolTechnology: FC = withProcedureWraper(() => {
  const history = useHistory();
  const user = useSelector(state => state.user);
  const currentUserName = user?.current?.username;

  const getITToolRequests = () => {
    return ITToolRequestService.getITToolRequests(currentUserName, requestStatus.submitted).then(res => {
      return { data: res.reverse(), count: res.length }
    }, () => {
      return { data: [], count: 0 }
    });
  }

  const getMyITToolRequests = () => {
    return ITToolRequestService.getITToolRequests(currentUserName).then(res => {
      return { data: res.reverse(), count: res.length }
    }, () => {
      return { data: [], count: 0 }
    });
  }

  const getStatusBaseOnApprover = (item: any) => {
    const { eApprovedBy, eApprovedByITLead, eApprovedByITHead, eAssignee, eRequestStatus } = item;
    if (!eRequestStatus) {
      const approverEmail = eApprovedBy ? eApprovedBy.split('|')[1] : '';
      const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split('|')[1] : '';
      const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split('|')[1] : '';
      const assigneeEmail = eAssignee ? eAssignee.split('|')[1] : '';
      if (currentUserName.toLowerCase() === approverEmail.toLowerCase()) {
        return item.eApprovedStatus || requestStatus.submitted;
      } else if (currentUserName.toLowerCase() === approvedByITLeadEmail.toLowerCase()) {
        return item.eApprovedByITLeadStatus || requestStatus.submitted;
      } else if (currentUserName.toLowerCase() === approvedByITHeadEmail.toLowerCase()) {
        return item.eApprovedByITHeadStatus || requestStatus.submitted;
      } else if (currentUserName.toLowerCase() === assigneeEmail.toLowerCase()) {
        return item.eAssigneeStatus || requestStatus.submitted;
      }
    } else {
      return eRequestStatus;
    }
  }

  const getStepBaseOnApprover = (item: any) => {
    const { eApprovedBy, eApprovedByITLead, eApprovedByITHead, eAssignee } = item;
    const approverEmail = eApprovedBy ? eApprovedBy.split('|')[1] : '';
    const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split('|')[1] : '';
    const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split('|')[1] : '';
    const assigneeEmail = eAssignee ? eAssignee.split('|')[1] : '';
    if (currentUserName.toLowerCase() === approverEmail.toLowerCase()) {
      return approverType.approver;
    } else if (currentUserName.toLowerCase() === approvedByITLeadEmail.toLowerCase()) {
      return approverType.itlead;
    } else if (currentUserName.toLowerCase() === approvedByITHeadEmail.toLowerCase()) {
      return approverType.ithead;
    } else if (currentUserName.toLowerCase() === assigneeEmail.toLowerCase()) {
      return approverType.assignee;
    }
  }

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
      <div className="text-md-center font-weight-bold p-3 bg-info text-white" style={{fontSize:"20px"}}>
        Cấp Công Cụ CNTT</div>
        <Box
          title="Yêu cầu của tôi "
          titleRight={<div className="btnPlus" onClick={() => history.push(Routes.createToolTechnologyPage.path.replace(':id', '0'))}>
            <Icon.Plus />Tạo yêu cầu
          </div>}
        >
          <Table
            className="table"
            onRowClick={(item) =>  history.push(Routes.itToolDetailPage.path.replace(':id', item.id))}
            structure={[
              {
                name: 'Ngày tạo',
                render: (item) => getDDMMYYYFormat(item.createdDateTime)
              },
              {
                name: 'Nhân viên',
                render: (item) => {
                  return `${item.createdBy.user.displayName}`
                }
              },
              {
                name: 'Yêu cầu',
                render: (item) => <>
                  <span className="flag success">
                    {toolTechnologyRequestTypes && item.fields.eRequestType && toolTechnologyRequestTypes.find(o => o.value === item.fields.eRequestType)?.label}
                  </span>
                </>
              },
              {
                name: 'Công cụ',
                render: (item) => item.fields.Title
              },
              {
                name: 'Mô tả',
                render: (item) => item.fields.eDescription
              },
              {
                name: 'Trạng thái',
                render: (item) => <ApprovalStatus status={item.fields.eRequestStatus} />
              }
            ]}
            onFetchData={getMyITToolRequests}
          />
        </Box>

        <Box title="Các yêu cầu cần duyệt"
          titleRight={
            <div className="d-flex m-2">
              <div className="btnPlus" onClick={() => history.push(Routes.itToolDetailPage.path)}>
                {'Xem lịch sử duyệt'}
              </div>
              <div>
                <Button disabled={true} title={'Xuất file'} className="" variant="outline-danger"><FontFa name="faPrint" size={'xs'} /></Button>
              </div></div>
          }>
          <Table
            onRowClick={(item) => history.push(Routes.itToolDetailPage.path.replace(':id', item.id))}
            structure={[
              {
                name: 'Ngày tạo',
                render: (item) => getDDMMYYYFormat(item.createdDateTime)
              },
              {
                name: 'Nhân viên',
                render: (item) => {
                  return `${item.createdBy.user.displayName}`
                }
              },
              {
                name: 'Yêu cầu',
                render: (item) => <>
                  <span className="flag success">
                    {toolTechnologyRequestTypes && toolTechnologyRequestTypes.find(o => o.value === item.fields.eRequestType)?.label}
                  </span>
                </>
              },
              {
                name: 'Công cụ',
                render: (item) => item.fields.Title
              },
              {
                name: 'Mô tả',
                render: (item) => item.fields.eDescription
              },
              {
                name: 'Trạng thái',
                render: (item) => {
                  const status = getStatusBaseOnApprover(item.fields);
                  const step = getStepBaseOnApprover(item.fields);
                  if (status === requestStatus.submitted) return <span className="flag warning">
                    {step === approverType.assignee ? 'Đang đợi thực thi' : 'Đang đợi duyệt'}
                  </span>

                  if (status === requestStatus.approved) return <span className="flag success">
                    {'Đã duyệt'}
                  </span>

                  if (status === requestStatus.inProgress) return <span className="flag info">
                    {'Đang thực thi'}
                  </span>

                  if (status === requestStatus.rejected) return <span className="flag danger">
                    {'Đã từ chối'}
                  </span>

                  if (status === requestStatus.completed) return <span className="flag success">
                    {`Đã ${toolTechnologyRequestTypes.find(o => o.value === item.fields.eRequestType)?.label}`}
                  </span>
                }
              }
            ]}
            onFetchData={getITToolRequests}
          />
        </Box>
      </div>
    </div>
  )
})